/* eslint-disable react/state-in-constructor */
import React, { PureComponent } from 'react';
import ToastEvents from './ToastEvents';
import Toast, { type ToastProps } from './Toast';

type OwnState = {
  toastOptions: ToastProps | null;
};

class ToastManager extends PureComponent<unknown, OwnState> {
  containerTimeout = 0;

  state: OwnState = {
    toastOptions: null
  };

  componentDidMount() {
    ToastEvents.mount(this);
  }

  componentWillUnmount() {
    this.closeToast();
    clearTimeout(this.containerTimeout);
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  showToast = (options: ToastProps) => {
    this.setState({ toastOptions: options });
  };

  closeToast = () => {
    const { toastOptions } = this.state;
    this.setState(
      {
        toastOptions: {
          ...toastOptions,
          animationClass: 'on-leave'
        }
      },
      () => {
        this.containerTimeout = window.setTimeout(() => {
          this.setState({ toastOptions: null });
        }, 500);
      }
    );
  };

  render() {
    const { toastOptions } = this.state;

    return toastOptions ? <Toast {...toastOptions} closeToast={this.closeToast} /> : null;
  }
}

export default ToastManager;
